import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";
import Button from "../../components/Button";
import { Check } from "lucide-react";

const points1 = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Brochures, Posters and Banners" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Premium branded look" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Leaflets, Standees & Print Ads" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Save ₹50,000+ in design costs" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Custom branding strategy" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Reach more local parents" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Parent engagement boost" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Become the #1 choice" },
];

const points2 = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "CS (Company Secretary) Assistance" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Company Registration & Compliance" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "CA (Chartered Accountant) Assistance" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Accounting, audits & tax filing (save ₹1 lakh/yr)" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Legal Advisory Support" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Permissions, contracts & documentation" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "AI Business Guidance" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Plan finances, operations & marketing" },
];

const data = [{
    title: "School Complete Marketing Toolkit",
    description: <div className="space-y-3">
        <ul className="grid grid-cols-2 gap-2">
            {points1.map((section, index) => (<div className="flex items-center gap-2">
                {section?.icon}
                <li key={"Complete" + index}><Text label={section.text} cName="text-gray-700 text-xs leading-relaxed" /></li>
            </div>
            ))}
        </ul>
        <div className="flex md:flex-col items-center gap-4">
            <Button label='Activate AI for Startups' type='gradient' />
            <Button label='Join Live Webinar' type='outlined' />
        </div>
    </div>,

}, {
    title: "CS, CA and Legal Assistance- AI Support Suite",
    description: <div className="space-y-3">
        <ul className="grid grid-cols-2 md:grid-cols-1 gap-2">
            {points2.map((section, index) => (<div className="flex items-center gap-2">
                {section?.icon}
                <li key={"Legal" + index}><Text label={section.text} cName="text-gray-700 text-xs leading-relaxed" /></li>
            </div>
            ))}
        </ul>
    </div>,

}];


export default function GrowFaster() {

    return (
        <Box
            badge={"MORE BENEFITS FOR STARTUPS"}
            title={"Grow faster with done‑for‑you assets & expert guidance"}
            description={"In india 80% of the population cannot understand, read/write in english but the mode of communication used by schools to update parents is normally sms that too in English,  leading to failure in clear communication and updates the parents receive about their children like exams, marks, fees, attendance, homework etc."}
            leftBlock={data.map((member, index) => <MarktingCard key={"AutoConnect" + index} member={member} />)}
        />
    );
}